/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Row } from './Row';
import {
    RowFromJSON,
    RowFromJSONTyped,
    RowToJSON,
} from './Row';

/**
 * 
 * @export
 * @interface RowData
 */
export interface RowData {
    /**
     * The number of rows after filtering, or null if row counting is disabled.
     * @type {number}
     * @memberof RowData
     */
    count?: number;
    /**
     * The number of rows without filtering, or null if row counting is disabled.
     * @type {number}
     * @memberof RowData
     */
    countAll?: number;
    /**
     * 
     * @type {Array<Row>}
     * @memberof RowData
     */
    rows: Array<Row>;
}

/**
 * Check if a given object implements the RowData interface.
 */
export function instanceOfRowData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "rows" in value;

    return isInstance;
}

export function RowDataFromJSON(json: any): RowData {
    return RowDataFromJSONTyped(json, false);
}

export function RowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RowData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'countAll': !exists(json, 'countAll') ? undefined : json['countAll'],
        'rows': ((json['rows'] as Array<any>).map(RowFromJSON)),
    };
}

export function RowDataToJSON(value?: RowData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'countAll': value.countAll,
        'rows': ((value.rows as Array<any>).map(RowToJSON)),
    };
}

